<template>
    <div>
        <div class="top">
            <van-nav-bar
                :title="schoolInfo.name"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
            />
        </div>
        <div class="school-photo" @click="goSchoolVr(schoolInfo)">
            <img :src="vr" />
            <div class="vr-text-tip">点击查看全景</div>
        </div>
        <div class="content">
            <div class="school">
                <div class="school-logo">
                    <img :src="schoolInfo.logo" />
                </div>
                <div class="school-name">{{schoolInfo.name}}</div>
            </div>
            <div class="tag">
                <div class="tags" v-for="(item,index) in schoolInfo.tags" :key="index">{{item}}</div>
            </div>
            <div class="school-info">
                <div class="info">建校时间:{{schoolInfo.school_year}}</div>
                <div class="info">院校类别:{{schoolInfo.school_type}}</div>
            </div>
            <div class="school-info">
                <div class="info">院校类型:{{schoolInfo.college_type}}</div>
                <div class="info">学校地址:{{schoolInfo.address}}</div>
            </div>

            <div class="menu">
                <div class="menu-item" v-for="item in cates" :key="item.id" @click="goDetail(item)">
                    <div class="menu-img">
                        <img :src="item.cate_img" alt />
                    </div>
                    <div>{{item.name}}</div>
                </div>
            </div>
            <van-list
                class="news"
                v-for="(item,index) in newsList"
                :key="index"
                @load="onLoad"
                :finished="finished"
            >
                <!--三图-->
                <div class="news-item" v-if="item.picnum === 3" @click="goDetails(item.id)">
                    <div class="news-title">{{item.title}}</div>
                    <div class="news-img">
                        <div class="img-three" v-for="(i,index) in item.thumb" :key="index">
                            <img :src="i" />
                        </div>
                    </div>
                    <div class="create-time">{{item.create_time}}</div>
                </div>
                <!--二图-->
                <div class="news-item" v-if="item.picnum === 2" @click="goDetails(item.id)">
                    <div class="news-title">{{item.title}}</div>
                    <div class="news-img">
                        <div class="img-two" v-for="(i,index) in item.thumb" :key="index">
                            <img :src="i" />
                        </div>
                    </div>
                    <div class="create-time">{{item.create_time}}</div>
                </div>
                <!--单图-->
                <div class="news-item" v-if="item.picnum === 1" @click="goDetails(item.id)">
                    <div class="news-one">
                        <div class="title-one">{{item.title}}</div>
                        <div class="img-one" v-for="(i,index) in item.thumb" :key="index">
                            <img :src="i" />
                        </div>
                    </div>
                    <div class="create-time">{{item.create_time}}</div>
                </div>
                <!--无图-->
                <div class="news-item" v-if="item.picnum === 0" @click="goDetails(item.id)">
                    <div class="news-title">{{item.title}}</div>
                    <div class="create-time">{{item.create_time}}</div>
                </div>
            </van-list>
        </div>
        <div v-if="chatShow">
            <div class="service" @click="chat"></div>
        </div>
    </div>
</template>

<script>
import { httpPost, httpGet } from "../../../../axios/index";

import share from "../../../../util/share.js";
export default {
    name: "schoolDetail",
    data() {
        return {
            schoolInfo: {},
            cates: [],
            noticeList: [],
            newsList: [],
            vr: "",
            vr_link: "",
            school: "",
            page: 0,
            finished: false,
            chatShow: false, //群聊显示
            showLogin: false
        };
    },
    methods: {
        // 点击上拉加载
        onLoad() {
            this.page = this.page + 1;
            httpPost("/saas/home", {
                schoolid: this.$route.query.id,
                page: this.page
            }).then(res => {
                if (res.code === 1) {
                    this.newsList = [...this.newsList, ...res.data];
                } else {
                    this.finished = true;
                }
            });
        },
        //点击查看学校全景、
        goSchoolVr() {
            this.$store.state.linkurl = this.vr_link;
            this.$router.push("/schoolVr");
        },
        goDetails(e) {
            this.$router.push({
                path: "/bzNewsDetail",
                query: {
                    id: e
                }
            });
        },
        goNewsDetail(e) {
            this.$router.push({
                path: "/news/newsDetail",
                query: {
                    id: e.id
                }
            });
        },
        onClickLeft() {
            this.$router.go(-1);
        },
        goDetail(item) {
            this.$router.push({
                path: item.cate_url,
                query: {
                    id: this.$route.query.id
                }
            });
        },
        // 获取支付数据
        fetchPayData() {
            httpPost("/school/empower_vr", {
                schoolid: this.$route.query.id,
                uid: this.$store.state.userInfo.user_id
            }).then(response => {
                if (response.code === 1) {
                }
            });
        },
        // 获取学校详情数据
        loadSchoolInfo() {
            httpPost("/saas/index", { schoolid: this.$route.query.id }).then(
                response => {
                    if (response.code === 1) {
                        this.schoolInfo = response.school;
                        this.cates = response.cates;
                        this.noticeList = response.notice;
                        this.vr = response.vr;
                        this.newsList = response.news;
                        this.vr_link = response.vr_url;
                        share(response.school);
                    }
                }
            );
        },
        // 群聊
        chat() {
            if (this.$store.state.userInfo.user_id != 0) {
                httpPost("/school/group_chat", {
                    sid: this.$store.state.schoolId
                }).then(res => {
                    if (res.code == 1) {
                        this.groupId = res.accesskey;
                    }
                    this.$router.push({
                        path: "/ims",
                        query: {
                            groupId: this.groupId
                        }
                    });
                    console.log(this.groupId);
                });
            }
        }
    },
    mounted() {
        this.$store.state.schoolId = this.$route.query.id;
        this.fetchPayData();
        this.loadSchoolInfo();
        // 是否开通群聊
        httpPost("/school/group_chat", { sid: this.$route.query.id }).then(
            res => {
                if (res.code == 1) {
                    this.chatShow = true;
                }
            }
        );
    }
};
</script>

<style scoped>
.content {
    background: #f2f2f2;
}

.school-photo {
    height: 18rem;
    position: relative;
}

img {
    width: 100%;
    height: 100%;
}

.vr-text-tip {
    position: absolute;
    bottom: 0.5rem;
    left: 0.5rem;
    z-index: 9;
    color: #fff;
    padding: 0.2rem;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0.4rem;
}

.school {
    background: #fff;
    display: flex;
    padding: 0.5rem;
}

.school-logo {
    width: 4rem;
    height: 4rem;
}

.school-name {
    font-size: 1.2rem;
    color: #383838;
    line-height: 4rem;
    padding-left: 1.5rem;
}
.tag {
    background: #fff;
}
.tags {
    display: inline-block;
    border: 0.05rem solid #ffae28;
    padding: 0.1rem 0.4rem;
    border-radius: 0.5rem;
    margin-left: 0.5rem;
}

.school-info {
    display: flex;
    background: #fff;
}

.info {
    margin-left: 0.5rem;
    padding-top: 0.5rem;
    font-size: 1rem;
    color: #383838;
}

.info:nth-child(2) {
    padding-left: 2rem;
}

.toutiao {
    padding: 0 0.5rem;
    height: 3rem;
    margin: 0.5rem 0;
    display: flex;
    align-items: center;
    background: #fff;
}

.voice {
    font-size: 1.5rem;
    color: #f96266;
}

.tips {
    font-size: 1rem;
    padding-top: 0.2rem;
    padding-left: 0.2rem;
}

.notice {
    width: 80%;
    height: 100%;
    padding-left: 1rem;
}

.toutiao .swiper {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.toutiao .van-swipe-item {
    padding-top: 0.2rem;
    display: flex;
    align-items: center;
    height: 100%;
    color: #ed4149;
    font-size: 0.8rem;
}

.menu {
    display: flex;
    background: #fff;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
    margin-top: 8px;
}
.menu-item {
    width: 17vw;
    text-align: center;
    margin-left: 2.5vw;
    margin-top: 0.5rem;
}
.menu-img {
    width: 13vw;
    height: 13vw;
    margin: 0 auto;
}
.news {
    background: #fff;
}
.news-item {
    padding: 0.8rem 0;
    border-bottom: 0.05rem solid #ccc;
}
.news-title {
    font-size: 1rem;
    padding-left: 0.3rem;
    padding-bottom: 0.5rem;
}
.news-one {
    display: flex;
}
.img-one {
    width: 35vw;
    height: 6rem;
    margin-left: 5vw;
}
.title-one {
    width: 55vw;
    font-size: 1rem;
    padding-left: 0.5rem;
}
.create-time {
    padding-left: 0.3rem;
    padding-top: 0.6rem;
    color: #999;
}
.news-img {
    display: flex;
    justify-content: space-around;
}
.img-three {
    width: 30vw;
    height: 5rem;
}
.img-two {
    width: 45vw;
    height: 6rem;
}
.service {
    width: 2.5rem;
    height: 2.5rem;
    position: fixed;
    right: 0.3125rem;
    top: 100vw;
    background: url("https://new.schoolpi.net/attach/small_program/group/ims-btn.png");
    background-size: 100%;
}
</style>